// src/data/loadingData.js

export const triviaList = [
  { 
    question: "What is the capital city of Bhutan?", 
    answer: "Thimphu", 
    choices: ["Kathmandu", "Colombo", "Thimphu"] 
  },
  { 
    question: "What is the capital city of Mongolia?", 
    answer: "Ulaanbaatar", 
    choices: ["Astana", "Tashkent", "Ulaanbaatar"] 
  },
  { 
    question: "What is the rarest blood type among humans?", 
    answer: "AB-negative", 
    choices: ["O-negative", "AB-negative", "B-negative"] 
  },
  { 
    question: "How many wives did King Henry VIII have?", 
    answer: "Six", 
    choices: ["Eight", "Four", "Six"] 
  },
  { 
    question: "In which year did Serena Williams win her first Grand Slam singles title?", 
    answer: "1999 (US Open)", 
    choices: ["1999 (US Open)", "1998 (French Open)", "2000 (Wimbledon)"] 
  },
  { 
    question: "In what year and in which city were the first modern Olympic Games held?", 
    answer: "1896 in Athens, Greece", 
    choices: ["1896 in Athens, Greece", "1892 in London, England", "1900 in Paris, France"] 
  },
  { 
    question: "What is the specific term used to describe a type of sandstorm characterized by strong winds carrying a wall of dust and sand, reducing visibility and causing hazardous conditions?", 
    answer: "Haboob", 
    choices: ["Dust Devil", "Haboob", "Sirocco"] 
  },
  { 
    question: "Benjamin Franklin was a key figure in the drafting of the United States Constitution. Which state did he represent during the Constitutional Convention in 1787?", 
    answer: "Pennsylvania", 
    choices: ["Virginia", "Massachusetts", "Pennsylvania"] 
  },
  { 
    question: "Before founding Facebook, Mark Zuckerberg created a website that allowed users to compare the attractiveness of two people side by side. What was the name of this website?", 
    answer: "Facemash", 
    choices: ["Facemash", "Bookface", "TheFacebook"] 
  },
  { 
    question: "In the early 20th century, a soft drink named “Bib-Label Lithiated Lemon-Lime Soda” was known for containing lithium. Which company later acquired this beverage and transformed it into a popular lemon-lime soft drink we know today?", 
    answer: "Coca-Cola Company (they rebranded it as 7UP)", 
    choices: [
      "Dr Pepper Snapple Group (they rebranded it as 7UP)",
      "PepsiCo (they rebranded it as Sprite)",
      "Coca-Cola Company (they rebranded it as 7UP)"
    ] 
  },

  {
    question: "What is the largest planet in our solar system?",
    answer: "Jupiter",
    choices: ["Saturn", "Neptune", "Jupiter"]
  },
  {
    question: "What is the chemical symbol for gold?",
    answer: "Au",
    choices: ["Ag", "Au", "Pb"]
  },
  {
    question: "Which element has the atomic number 6?",
    answer: "Carbon",
    choices: ["Oxygen", "Carbon", "Nitrogen"]
  },
  {
    question: "What year did World War II end?",
    answer: "1945",
    choices: ["1944", "1945", "1946"]
  },
  {
    question: "Who painted the Mona Lisa?",
    answer: "Leonardo da Vinci",
    choices: ["Michelangelo", "Raphael", "Leonardo da Vinci"]
  },
  {
    question: "What is the smallest prime number?",
    answer: "2",
    choices: ["1", "2", "3"]
  },
  {
    question: "Which country is known as the Land of the Rising Sun?",
    answer: "Japan",
    choices: ["China", "Japan", "Thailand"]
  },
  {
    question: "What is the hardest natural substance on Earth?",
    answer: "Diamond",
    choices: ["Quartz", "Diamond", "Corundum"]
  },
  {
    question: "Which language has the most native speakers?",
    answer: "Mandarin Chinese",
    choices: ["English", "Hindi", "Mandarin Chinese"]
  },
  {
    question: "What is the capital of Australia?",
    answer: "Canberra",
    choices: ["Sydney", "Melbourne", "Canberra"]
  },
  {
    question: "Who is the author of '1984'?",
    answer: "George Orwell",
    choices: ["Aldous Huxley", "George Orwell", "Ray Bradbury"]
  },
  {
    question: "What is the boiling point of water at sea level in Celsius?",
    answer: "100°C",
    choices: ["90°C", "100°C", "110°C"]
  },
  {
    question: "Which gas do plants absorb from the atmosphere?",
    answer: "Carbon dioxide",
    choices: ["Oxygen", "Nitrogen", "Carbon dioxide"]
  },
  {
    question: "Who discovered penicillin?",
    answer: "Alexander Fleming",
    choices: ["Louis Pasteur", "Alexander Fleming", "Marie Curie"]
  },
  {
    question: "What is the largest mammal in the world?",
    answer: "Blue whale",
    choices: ["Elephant", "Blue whale", "Giraffe"]
  },
  {
    question: "Which planet is known as the Red Planet?",
    answer: "Mars",
    choices: ["Mars", "Venus", "Mercury"]
  },
  {
    question: "What is the main language spoken in Brazil?",
    answer: "Portuguese",
    choices: ["Spanish", "Portuguese", "French"]
  },
  {
    question: "Who composed the Four Seasons?",
    answer: "Antonio Vivaldi",
    choices: ["Johann Sebastian Bach", "Antonio Vivaldi", "Wolfgang Amadeus Mozart"]
  },
  {
  question: "Which mathematician proved Fermat’s Last Theorem in 1994?",
  answer: "Andrew Wiles",
  choices: ["Pierre de Fermat", "Gerhard Frey", "Andrew Wiles"]
},
{
  question: "In quantum mechanics, what principle states you cannot simultaneously know position and momentum exactly?",
  answer: "Heisenberg Uncertainty Principle",
  choices: ["Pauli Exclusion Principle", "Heisenberg Uncertainty Principle", "Bohr Correspondence Principle"]
},
{
  question: "What is the only U.S. state whose name is an anagram of its capital?",
  answer: "Oklahoma",
  choices: ["Texas", "Oklahoma", "Alabama"]
},
{
  question: "Which 18th‑century composer was nicknamed 'The Red Priest'?",
  answer: "Antonio Vivaldi",
  choices: ["Johann Pachelbel", "Antonio Vivaldi", "Georg Philipp Telemann"]
},
{
  question: "In computer science, what does the acronym 'RSA' stand for in public-key cryptography?",
  answer: "Rivest–Shamir–Adleman",
  choices: ["Rivest–Shamir–Adleman", "RSA is not an acronym", "Rivest–Shannon–Adams"]
},
{
  question: "What is the name of the sequence defined by a₀ = 0, a₁ = 1, and aₙ = aₙ₋₁ + aₙ₋₂?",
  answer: "Fibonacci sequence",
  choices: ["Lucas sequence", "Fibonacci sequence", "Pell sequence"]
},
{
  question: "Which novel begins with the line, 'Call me Ishmael'?",
  answer: "Moby-Dick",
  choices: ["Moby-Dick", "The Old Man and the Sea", "Heart of Darkness"]
},
{
  question: "What organ in the human body produces the hormone insulin?",
  answer: "Pancreas",
  choices: ["Liver", "Pancreas", "Adrenal gland"]
},
{
  question: "In astronomy, what is the name for a star that suddenly increases in brightness then fades?",
  answer: "Nova",
  choices: ["Supernova", "Nova", "Quasar"]
},
{
  question: "Which painter is credited with pioneering Cubism along with Pablo Picasso?",
  answer: "Georges Braque",
  choices: ["Henri Matisse", "Georges Braque", "Salvador Dalí"]
},
{
  question: "What is the term for a word that is spelled the same forwards and backwards?",
  answer: "Palindrome",
  choices: ["Anagram", "Palindrome", "Oxymoron"]
},
{
  question: "In chemistry, what is the pH of a neutral solution at 25 °C?",
  answer: "7.0",
  choices: ["7.0", "6.0", "8.0"]
},
{
  question: "Who was the first woman to win a Nobel Prize (in 1903)?",
  answer: "Marie Curie",
  choices: ["Marie Curie", "Rosalind Franklin", "Irène Joliot-Curie"]
},
{
  question: "In Greek mythology, who is the god of the underworld?",
  answer: "Hades",
  choices: ["Poseidon", "Hades", "Ares"]
},
{
  question: "Which philosopher wrote 'Critique of Pure Reason'?",
  answer: "Immanuel Kant",
  choices: ["David Hume", "Immanuel Kant", "G.W.F. Hegel"]
},
{
  question: "What is the smallest non-zero eigenvalue of the Laplacian on a unit interval with Dirichlet boundary conditions?",
  answer: "π²",
  choices: ["π", "π²", "2π²"]
},
{
  question: "Which organelle is the site of ATP production in eukaryotic cells?",
  answer: "Mitochondrion",
  choices: ["Chloroplast", "Endoplasmic reticulum", "Mitochondrion"]
},
{
  question: "In economics, what term describes a market structure with a single seller?",
  answer: "Monopoly",
  choices: ["Oligopoly", "Monopoly", "Monopsony"]
},
{
  question: "Who formulated the laws of planetary motion?",
  answer: "Johannes Kepler",
  choices: ["Galileo Galilei", "Johannes Kepler", "Isaac Newton"]
},
{
  question: "Which literary movement is associated with authors like Camus and Sartre?",
  answer: "Existentialism",
  choices: ["Surrealism", "Existentialism", "Romanticism"]
},
{
  question: "What is the hardest known natural mineral after diamond?",
  answer: "Wurtzite boron nitride",
  choices: ["Corundum", "Cubic boron nitride", "Wurtzite boron nitride"]
},
{
  question: "Which programming paradigm emphasizes functions without side effects?",
  answer: "Functional programming",
  choices: ["Object-oriented programming", "Procedural programming", "Functional programming"]
},
{
  question: "What famous conjecture in number theory remains unproven: it asserts every even integer >2 is the sum of two primes?",
  answer: "Goldbach’s conjecture",
  choices: ["Twin prime conjecture", "Goldbach’s conjecture", "Riemann hypothesis"]
},
{
  question: "In relativity, what quantity remains invariant between different inertial frames?",
  answer: "The spacetime interval",
  choices: ["Mass", "Time", "The spacetime interval"]
},
{
  question: "Which chemist developed the periodic table based on atomic weight in 1869?",
  answer: "Dmitri Mendeleev",
  choices: ["John Dalton", "Dmitri Mendeleev", "Lothar Meyer"]
},
{
  question: "What is the capital of Mongolia’s autonomous region of Inner Mongolia (in China)?",
  answer: "Hohhot",
  choices: ["Urumqi", "Hohhot", "Lhasa"]
},
{
  question: "Which composer wrote the opera 'The Ring of the Nibelung'?",
  answer: "Richard Wagner",
  choices: ["Giuseppe Verdi", "Richard Wagner", "Wolfgang Amadeus Mozart"]
},
{
  question: "In graph theory, what is the maximum number of edges in a simple graph with n vertices without creating a cycle?",
  answer: "n–1",
  choices: ["n", "n–1", "n(n–1)/2"]
},
{
  question: "Which noble gas has the highest atomic number that occurs naturally?",
  answer: "Radon",
  choices: ["Xenon", "Radon", "Krypton"]
},
{
  question: "What is the name of the effect describing light bending around massive objects?",
  answer: "Gravitational lensing",
  choices: ["Doppler effect", "Gravitational lensing", "Photoelectric effect"]
},
{
  question: "Which economist wrote 'The General Theory of Employment, Interest and Money' in 1936?",
  answer: "John Maynard Keynes",
  choices: ["Milton Friedman", "John Maynard Keynes", "Adam Smith"]
},
{
  question: "In topology, what is a surface with genus 0 and no boundary called?",
  answer: "Sphere",
  choices: ["Torus", "Mobius strip", "Sphere"]
}
];




export const gifList = [
  "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExazBmaDlkOTY2eTE4bHRyNWV5dWJ6Zmh1ZzEyc3Z0ZnByb2w4Y3czdiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/eYAKbwOjhk7T2/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnZ1MDY3dXd1Y3ByczZlYnF5ZnA0ZWl3M3YwcXp6ZDZ6ZWwzNmMzbiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/12PA1eI8FBqEBa/giphy.gif",
  "https://media.giphy.com/media/4VY80dptzlyAo/giphy.gif?cid=ecf05e477ag4xakb3cuieolu8x5cedu7kllz45hijzkflz5y&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/11jgXRmOxyWYP6/giphy.gif?cid=ecf05e477ag4xakb3cuieolu8x5cedu7kllz45hijzkflz5y&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/7iKjrebrvGnRIaPDYy/giphy.gif?cid=ecf05e477ag4xakb3cuieolu8x5cedu7kllz45hijzkflz5y&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/f1qY05BqNBjDZef2PN/giphy.gif?cid=ecf05e47cjkjmzjgx8mf8hnhqpeeaoblekalpsb0s0cmtk5a&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/nzln2Ictu7tmYDuimh/giphy.gif?cid=ecf05e47cjkjmzjgx8mf8hnhqpeeaoblekalpsb0s0cmtk5a&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExODQ0dmFvaWc2bGN0dnJ1cWx3dmIxbTQ5b3lvcXlkM3Flb212MzVtYyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/WeUNAgfPwrOs3SjiM7/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNmJsMTgyOWVkcDFmbmZhajh3NGRlOWFmZjBnN2tmOW1zOGF3cTdxdCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3og0Iu3ui5KrDSoGsg/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2k0bWYyb24wd3Bua2RubHZxcjgyOWloaHlia3Z6YzJlbDF2OXhydCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3oz8xZMfSwxtD2ygAo/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2k0bWYyb24wd3Bua2RubHZxcjgyOWloaHlia3Z6YzJlbDF2OXhydCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/l0MYDpn2FgCuir2ow/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZGN4YzR6YTB2OG04ODdudzJlajB3dTFmdG41d2hvaGI0Nm91a2J3diZlcD12MV9naWZzX3NlYXJjaCZjdD1n/EatwJZRUIv41G/giphy.gif",
  "https://media.giphy.com/media/fAaBpMgGuyf96/giphy.gif?cid=ecf05e47pwvlad1o75gz9r6fc92l7nxprnq7jchofd3msndf&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMzZqdjZrMjJ1Z2JpcDV4eHdsazllNXl6d293d2QxaTdmZzFwMWQ2aiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/iDJQRjTCenF7A4BRyU/giphy.gif",
  "https://media.giphy.com/media/ZyT7OVt78WZmE/giphy.gif?cid=ecf05e47lpac5tf3ela1kp5eikm26gc419c6t5ax1ffm9tqi&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdnN1NjFvaXJ3ZXFvajJwOW05d2gzejk4bGEwbWVjMHd2ZDFuOTh6byZlcD12MV9naWZzX3NlYXJjaCZjdD1n/55rfPYTDbfpXImdklL/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdnN1NjFvaXJ3ZXFvajJwOW05d2gzejk4bGEwbWVjMHd2ZDFuOTh6byZlcD12MV9naWZzX3NlYXJjaCZjdD1n/5DuXIgXMl3I9G/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdnVzZnltZWl2ZnZmdWdmZG95NnJ3ajJkemxta2RhYzcxa2NkOHpyeiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/l46CqLVMWzaJUFPLW/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExeGI5Z25zZDFjeGd6NjYyemY5c25iaXh4cTh3dW05MzJweG4wdWI2cCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/2djRaq10hCTrlyMKCU/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExc3QzNXd6aXNldGd3Mmwyd3A2MTEyZnA4Z2ZidjB4bDlxejQ5YmJ1aCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/PnPU9GhN3V7oVizSHG/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNWlrcXkzbTJrenU3bjh5Zzd6emE2ZTI3cTh5YXhxZnB3MzNmN3JyayZlcD12MV9naWZzX3NlYXJjaCZjdD1n/10AVDflAKRV86A/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExeWozZGFqMDVqNmNzODVnajgxZ2IzM3l6bmNwNDRobjB0ZGtneDZsayZlcD12MV9naWZzX3NlYXJjaCZjdD1n/WOkycZF1XsBestA9hU/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNHBzODFjamFkYm9vbDhqejZqM2IzeWt6Z3VqdW8xeGQzZDBxb2JnNyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3oeHLrjZGBgnPx5VII/giphy.gif",
  "https://media.giphy.com/media/7pUeCOT8YBtSw/giphy.gif?cid=ecf05e47vqm4wm41kl8f3qf3plrzkw4qhlv82uop1a4odfbp&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/JLxNGoSQ5jrsk/giphy.gif?cid=ecf05e47vqm4wm41kl8f3qf3plrzkw4qhlv82uop1a4odfbp&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExejN5Y3J1bDhxdjd3OXl5OWQzdG8zcWZoM3JtZjNqZGpqM2NiZWplcSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/9ErMGpYXUiuek/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExejN5Y3J1bDhxdjd3OXl5OWQzdG8zcWZoM3JtZjNqZGpqM2NiZWplcSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/J5CrrHAh2vSvfoFEAw/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExejN5Y3J1bDhxdjd3OXl5OWQzdG8zcWZoM3JtZjNqZGpqM2NiZWplcSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/9mFGk0j4Qqw4mvpJAA/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExejN5Y3J1bDhxdjd3OXl5OWQzdG8zcWZoM3JtZjNqZGpqM2NiZWplcSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/mMEbjQh1HbOU6wsgZM/giphy.gif",
  "https://media.giphy.com/media/oox5waSEYI3OwqMwrB/giphy.gif?cid=ecf05e47fgg7vmge43leocn8wwfyhoe4uw5bmoe2uj1j1xh4&ep=v1_gifs_search&rid=giphy.gif&ct=g",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExeWFtaGQyMTB3c2QxejNkOWIyNHY4NXFrYWk4aW4xbGF3Y200eHZ0MCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/dWr6FGbXhqJc6qoOHF/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZnBxMG9pbGwyaWNhb3Q1MXc1NTRqcGt1MWlmamwwcHN0cXIzeGNrMCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3ohzdRhLCSK1DEu1JC/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZnBxMG9pbGwyaWNhb3Q1MXc1NTRqcGt1MWlmamwwcHN0cXIzeGNrMCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3ov9jPZfN7pB7mDScU/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZnBxMG9pbGwyaWNhb3Q1MXc1NTRqcGt1MWlmamwwcHN0cXIzeGNrMCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/w5ZvhSeUXFnQA/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMXdyMWNnMGh6d2xncmFtZWl0a241cDJ0aGN3aTQxYXJmOG9maWtwOCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3o6nUVr4MVgKb9zDZ6/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMXdyMWNnMGh6d2xncmFtZWl0a241cDJ0aGN3aTQxYXJmOG9maWtwOCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/xTiN0uPQRihf3PwBKU/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExanN5dGt1a2Z0YnF3a3lxNDF1NjU4MjU2Z25mMzRqMjN3enJsYmthbiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/9fuvOqZ8tbZOU/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExanN5dGt1a2Z0YnF3a3lxNDF1NjU4MjU2Z25mMzRqMjN3enJsYmthbiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3osxYoufeOGOA7xiX6/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExanN5dGt1a2Z0YnF3a3lxNDF1NjU4MjU2Z25mMzRqMjN3enJsYmthbiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/u98zWbe3jgJoI/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExemFya2l3cmViOHIxbzY4a29rZmp4amp2c3VudHNvMmV5ZHN1b3ZseSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/YqHMVSYXIMEiA/giphy.gif",
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExemFya2l3cmViOHIxbzY4a29rZmp4amp2c3VudHNvMmV5ZHN1b3ZseSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/iaktyrUiG659e/giphy.gif",
  "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExdHNkMTByYjZpbDB0NnpuZTB2M2hzcGFvaXJjeGtsMDJzcHVoZ2cwMSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/JVrXj82TAUCWY/giphy.gif"

];